import { RayClusterIcon } from "@/components/Icons/RayClusterIcon";
// import { MegaRayIcon } from "@/components/Icons/MegaRayIcon";
// import { LudwigClusterIcon } from "@/components/Icons/LudwigClusterIcon";
import { ClusterType } from "@/types";
import { KubernetesIcon } from "@/components/Icons/KubernetesIcon";
// import { IoIcon } from "@/components/Icons/IoIcon";
// import { PlyTorchIcon } from "@/components/Icons/PlyTorchIcon";
// import { UnityIcon } from "@/components/Icons/UnityIcon";
// import { UnrealIcon } from "@/components/Icons/Unrealcon";
import env from "@/env";
import { BareMetalIcon } from "@/components/Icons/BareMetalIcon";
// import { BareMetalRequestIcon } from "@/components/Icons/BareMetalRequestIcon";
import { ContainerIcon } from "@/components/Icons/ContainerIcon.tsx";
import { VirtualMachineIcon } from "@/components/Icons/VirtualMachineIcon";
import { MagicBookIcon } from "@/components/Icons/MagicBookIcon";
import { BrainIcon } from "@/components/Icons/BrainIcon";

export const CLUSTER_ITEMS = [
  {
    value: ClusterType.CONTAINER,
    title: "Container Engine",
    subtitle: "Deploy your cluster of containers, powered by high-performance hardware",
    icon: ContainerIcon,
    url: "/cloud/container/create-cluster",
    disabled: !env.FEATUREFLAG_CONTAINER_DEPLOY
  },
  {
    value: ClusterType.BARE_METAL,
    title: "Bare Metal on demand",
    subtitle: "Deploy a Bare Metal Cluster",
    icon: BareMetalIcon,
    url: "/cloud/bare-metal/create-cluster",
    disabled: !env.FEATUREFLAG_BARE_METAL_DEPLOY
  },
  {
    value: ClusterType.RAY,
    title: "Ray",
    subtitle: "Deploy a Decentralized Ray Cluster",
    icon: RayClusterIcon,
    url: "/cloud/clusters/create-cluster",
    disabled: !env.FEATUREFLAG_CLUSTER_DEPLOYMENT_ENABLED
  },
  // {
  //   value: ClusterType.MEGA,
  //   title: "Mega-Ray",
  //   subtitle: "Deploy a Decentralized Mega-Ray Cluster",
  //   icon: MegaRayIcon,
  //   url: "/cloud/mega-clusters/create-cluster",
  //   disabled: !env.FEATUREFLAG_CLUSTER_DEPLOYMENT_ENABLED
  // },
  // {
  //   value: ClusterType.BARE_METAL_REQUEST,
  //   title: "Bare Metal Enterprise",
  //   subtitle: "Request a custom Enterprise Bare Metal Cluster",
  //   icon: BareMetalRequestIcon,
  //   url: "/cloud/bare-metal/request-cluster",
  //   disabled: !env.FEATUREFLAG_BARE_METAL_REQUEST
  // },
  {
    value: ClusterType.VMAAS,
    title: "Virtual Machine",
    subtitle: "Deploy an AI-ready virtual machine with pre-installed frameworks.",
    icon: VirtualMachineIcon,
    url: "/cloud/virtual-machines/create-cluster",
    disabled: !env.FEATUREFLAG_VMAAS_DEPLOY
  },
  {
    value: ClusterType.KUBERNETES,
    title: "Kubernetes",
    subtitle: "Deploy a Decentralized Kubernetes Cluster",
    icon: KubernetesIcon,
    url: "/cloud/kubernetes/create-cluster",
    disabled: !env.FEATUREFLAG_KUBERNETES_DEPLOY
  }
  // {
  //   value: ClusterType.LUDWIG,
  //   title: "Ludwig",
  //   subtitle: "Declarative deep learning framework built for scale and efficiency.",
  //   icon: LudwigClusterIcon,
  //   url: "/cloud/clusters/create-cluster",
  //   disabled: true
  // },
  // {
  //   value: ClusterType.RAY_APP,
  //   title: "Ray LLM",
  //   subtitle: "LLM serving at scale built on Ray Serve.",
  //   icon: RayClusterIcon,
  //   url: "/cloud/clusters/create-cluster",
  //   disabled: true
  // },
  // {
  //   value: "pytorch",
  //   title: "PyTorch FSDP",
  //   icon: PlyTorchIcon,
  //   url: "/cloud/clusters/create-cluster",
  //   disabled: true
  // },
  // {
  //   value: "ionative",
  //   title: "IO Native App",
  //   icon: IoIcon,
  //   url: "/cloud/clusters/create-cluster",
  //   disabled: true
  // },
  // {
  //   value: "unrealengine5",
  //   title: "Unreal Engine 5",
  //   icon: UnrealIcon,
  //   url: "/cloud/clusters/create-cluster",
  //   disabled: true
  // },
  // {
  //   value: "unitystreaming",
  //   title: "Unity Streaming",
  //   icon: UnityIcon,
  //   url: "/cloud/clusters/create-cluster",
  //   disabled: true
  // }
];

export const VM_IMAGE_OPTIONS = [
  {
    value: "general",
    label: "General Purpose Image",
    description:
      "OS: Ubuntu 24.04 64Bit \nSize: 3.5 GB (Uncompressed)\nAlong with NVIDIA CUDA Toolkit and associated drivers",
    cardIcon: MagicBookIcon,
    OsName: "Ubuntu 24.04 64Bit",
    OsSize: "3.5 GB (Uncompressed)",
    OsDescription: "Along with NVIDIA CUDA Toolkit and associated drivers"
  },
  {
    value: "datascience",
    label: "Data Science Image",
    description:
      "OS: Ubuntu 24.04.2 LTS x86_64/amd64 \nSize: 50GB\nNVIDIA drivers and CUDA libraries are pre-configured",
    cardIcon: BrainIcon,
    OsName: "Ubuntu 24.04.2 LTS x86_64/amd64",
    OsSize: "50GB",
    OsDescription: "NVIDIA drivers and CUDA libraries are pre-configured"
  }
];

export const RESTRICT_TO_SINGLE_LOCATION = false;
